import { Component } from '@angular/core';

@Component({
    selector: 'reddit-icon',
    template: '<img src="/assets/svgs/socials/reddit.svg" height=42 width=42 style="margin-top:-8px; margin-left:-10px">',
    styleUrls: ['../svg.component.scss']
})
export class RedditIcon {

}